import type { IUpdateOfficeSetupRequest } from '../types/UpdateOfficeSetup';
import type {
  IUpdateOfficeInfoApiPayload,
  IUpdateUserEducationApiPayload,
} from '../types/UpdateOfficeSetup.api';

const toUpdateOfficeInfoPayload = (
  input: IUpdateOfficeSetupRequest,
): IUpdateOfficeInfoApiPayload => ({
  office_info: {
    timePerPatientRDH: input.timePerPatientRDH,
    timePerPatientDA: input.timePerPatientDA,
    timePerPatientDN: input.timePerPatientDN,
    isAssistedHygiene: input.isAssistedHygiene,
    is_info_asked: input.isInfoAsked,
  },
  parkingInformation: input.parkingInformation,
  ...(input.isProfileComplete && { is_profile_complete: true }),
});

const toUpdateUserEducationPayload = (
  input: IUpdateOfficeSetupRequest,
  existingSpecialtiesAndProcedures: Record<string, string[]>,
): IUpdateUserEducationApiPayload => ({
  education: {
    specialtiesAndProcedures: { ...existingSpecialtiesAndProcedures },
    softwares: input.softwares,
  },
  insurances: input.insurances,
});

export const UpdateOfficeSetupAdapters = {
  toUpdateOfficeInfoPayload,
  toUpdateUserEducationPayload,
};
